import React from "react";
import PixError from "../../../../images/icons-figma/pix-error.svg";
import * as S from "./styles.js";

function PixBadRequestScreen(props) {
  return (
    <S.Container>
      <S.IconCircle>
        <img src={PixError} alt="" />
      </S.IconCircle>
      <S.Title>Ops! Algo deu errado.</S.Title>
      <S.SubTitle>
        Desculpe, tivemos alguns problemas durante sua última operação.
      </S.SubTitle>
      <S.Button onClick={props.onTryAgain}>Tentar novamente</S.Button>
    </S.Container>
  );
}

export default PixBadRequestScreen;
